// extracted by mini-css-extract-plugin
export default {"body":"EmbedSheet_body__LRu3h","controls":"EmbedSheet_controls__I13Fp","fineprint":"EmbedSheet_fineprint__spLf2"};